import {DispatchApi} from "../../core/dispatch/dispatch";
import {useToken} from "../../state/UserContextProvider";
import type {CopyModuleResult, ModuleDescriptor, ModuleDetail, ModulePrototype, NamespaceOption} from "./types";

class ModuleEditorDispatchApi extends DispatchApi {
    constructor(token: string | undefined | null) {
        super(token, "moduleEditor", false);
    }

    async listModules(): Promise<ModuleDescriptor[]> {
        return this.dispatch<ModuleDescriptor[]>("listModules");
    }

    async getModule(namespace: string, moduleId: string, version?: string): Promise<ModuleDetail> {
        return this.dispatch<ModuleDetail>("getModule", {namespace, moduleId, version});
    }

    async createModule(moduleId: string, module: ModulePrototype): Promise<ModuleDetail> {
        return this.dispatch<ModuleDetail>("createModule", {moduleId, module});
    }

    async updateModule(namespace: string, moduleId: string, module: ModulePrototype): Promise<ModuleDetail> {
        return this.dispatch<ModuleDetail>("updateModule", {namespace, moduleId, module});
    }

    async deleteModule(namespace: string, moduleId: string): Promise<void> {
        return this.dispatch<void>("deleteModule", {namespace, moduleId});
    }

    async promoteModule(namespace: string, moduleId: string, versionId: string, target: string): Promise<any> {
        return this.dispatch("promoteModule", {namespace, moduleId, versionId, target});
    }

    async listNamespaces(): Promise<NamespaceOption[]> {
        return this.dispatch<NamespaceOption[]>("listNamespaces");
    }

    async copyModule(moduleId: string, sourceNamespace: string, targetNamespace: string, overwrite: boolean): Promise<CopyModuleResult> {
        return this.dispatch<CopyModuleResult>("copyModule", {moduleId, sourceNamespace, targetNamespace, overwrite});
    }
}

export function useModuleEditorApi() {
    return new ModuleEditorDispatchApi(useToken());
}
